import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { Link } from '@/i18n/navigation';
import { ArrowRight, BookOpenIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AnimatedGrid, AnimatedSection, LazyImage, NoImagePlaceholder } from '@/components/partials';
import { buildTranslatedRoute, getAppLocale } from '@/lib/utils.server';
import { formatLongDateTime, getLocalizedValue, getResizedPictureUrl, stripHtmlTags } from '@/lib/utils';
import { fetchBlogPosts } from '@/lib/api';
import { SortEnum } from '@/enums';
type PropsType = {
  itemSize?: number;
  title?: string;
  excludeIds?: string[];
};
const BlogPostsSection = async t0 => {
  const $ = _c(34);
  const {
    itemSize: t1,
    title,
    excludeIds: t2
  } = t0;
  const itemSize = t1 === undefined ? 3 : t1;
  const excludeIds = t2 === undefined ? undefined : t2;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== excludeIds || $[1] !== itemSize || $[2] !== title) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const t = await getTranslations();
      const {
        backendLocale
      } = await getAppLocale();
      const baseRoute = await buildTranslatedRoute(backendLocale, "blog");
      const {
        items: t13
      } = await fetchBlogPosts({
        excludeIds,
        page: 1,
        size: itemSize,
        sortBy: "createdAt",
        sort: SortEnum.DESC
      });
      const items = t13 === undefined ? [] : t13;
      if (items.length === 0) {
        t12 = null;
        break bb0;
      }
      const itemsWithLinks = await Promise.all(items.map(async item => ({
        ...item,
        detailHref: await buildTranslatedRoute(backendLocale, "blog", getLocalizedValue(item, "slug", backendLocale))
      })));
      t9 = "flex flex-col items-center justify-center space-y-8 px-4 py-20";
      t10 = <AnimatedSection animation="fade-up" className="w-full"><h2 className="text-center text-3xl font-bold uppercase">{title ?? t("blog")}</h2></AnimatedSection>;
      const t14 = itemsWithLinks.map(item_0 => {
        const title_0 = getLocalizedValue(item_0, "title", backendLocale);
        const content = getLocalizedValue(item_0, "content", backendLocale);
        if (title_0 === "-") {
          return null;
        }
        return <Link key={item_0.id} href={item_0.detailHref} className="group bg-card w-full overflow-hidden rounded-lg border transition-all hover:shadow-lg md:w-[calc(50%-0.75rem)] xl:w-[calc(33.333%-1rem)]"><div className="bg-muted relative flex h-48 w-full items-center justify-center overflow-hidden">{item_0.mainPicture ? <LazyImage src={getResizedPictureUrl(item_0.mainPicture.path, 800, 600)} alt={title_0} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw" className="object-cover transition-transform duration-300 group-hover:scale-110" /> : <NoImagePlaceholder icon={BookOpenIcon} />}</div><div className="space-y-3 p-5"><time className="text-muted-foreground text-sm">{formatLongDateTime(item_0.createdAt, backendLocale)}</time><h3 className="group-hover:text-primary text-xl font-semibold transition-colors">{title_0}</h3>{content && stripHtmlTags(content).trim() && <p className="text-muted-foreground line-clamp-3 text-sm">{stripHtmlTags(content)}</p>}</div></Link>;
      });
      if ($[15] !== t14) {
        t11 = <AnimatedGrid className="flex w-full max-w-7xl flex-wrap justify-center gap-6">{t14}</AnimatedGrid>;
        $[15] = t14;
        $[16] = t11;
      } else {
        t11 = $[16];
      }
      T1 = Button;
      t5 = true;
      t6 = "brand";
      t7 = "xl";
      t8 = "gap-2 uppercase";
      T0 = Link;
      t3 = baseRoute;
      t4 = t("view_all");
    }
    $[0] = excludeIds;
    $[1] = itemSize;
    $[2] = title;
    $[3] = T0;
    $[4] = T1;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ArrowRight className="h-5 w-5" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4) {
    t14 = <T0 href={t3}>{t4}{t13}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== T1 || $[23] !== t14 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t15 = <T1 asChild={t5} variant={t6} size={t7} className={t8}>{t14}</T1>;
    $[22] = T1;
    $[23] = t14;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t15 || $[32] !== t9) {
    t16 = <section className={t9}>{t10}{t11}{t15}</section>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t15;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
export default BlogPostsSection;